import axios from 'axios';

const API_URL = '/api/admin'; // Sesuaikan dengan URL backend Anda


// --- MWC Unit Management ---
const getMwc = async () => {
  try {
    const response = await axios.get(`${API_URL}/mwc`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const createMwc = async (mwcData) => {
  try {
    const response = await axios.post(`${API_URL}/mwc`, mwcData);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const updateMwc = async (id, mwcData) => {
  try {
    const response = await axios.put(`${API_URL}/mwc/${id}`, mwcData);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const deleteMwc = async (id) => {
  try {
    await axios.delete(`${API_URL}/mwc/${id}`);
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

// --- Ranting Unit Management ---
const getRanting = async () => {
  try {
    const response = await axios.get(`${API_URL}/ranting`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const createRanting = async (rantingData) => {
  try {
    const response = await axios.post(`${API_URL}/ranting`, rantingData);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const updateRanting = async (id, rantingData) => {
  try {
    const response = await axios.put(`${API_URL}/ranting/${id}`, rantingData);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const deleteRanting = async (id) => {
  try {
    await axios.delete(`${API_URL}/ranting/${id}`);
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

// --- User Management ---
const getUsers = async () => {
  try {
    const response = await axios.get(`${API_URL}/pengguna`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const createUser = async (userData) => {
  try {
    const response = await axios.post(`${API_URL}/pengguna`, userData);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const updateUser = async (id, userData) => {
  try {
    const response = await axios.put(`${API_URL}/pengguna/${id}`, userData);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const deleteUser = async (id) => {
  try {
    await axios.delete(`${API_URL}/pengguna/${id}`);
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};



// --- Global Performance Monitoring ---
const getGlobalPerformance = async (month, year) => {
  try {
    const response = await axios.get(`${API_URL}/kinerja/global`, { params: { month, year } });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const getGlobalRantingPerformance = async (month, year) => {
  try {
    const response = await axios.get(`${API_URL}/kinerja/ranting`, { params: { month, year } });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

export {
  getUsers,
  createUser,
  updateUser,
  deleteUser,
  getGlobalPerformance,
  getGlobalRantingPerformance, // Export new function
  getMwc,
  createMwc,
  updateMwc,
  deleteMwc,
  getRanting,
  createRanting,
  updateRanting,
  deleteRanting,
};
